var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgReasonDesktopBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "601px",
    height: "758px",
    viewBox: "0 0 601 758",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 46") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Starry-C",
    transform: "translate(0.000000, -899.000000)",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 899.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46",
    transform: "translate(-236.000000, -288.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,350.086816 C67.7505895,399.33389 109.028754,416.659668 139.834493,402.064147 C186.043102,380.170867 202.792991,288.277442 313.720502,298.507786 C424.648014,308.73813 466.722181,457.001176 562.259171,471.67291 C691.471751,503.88248 802.772235,350.944849 849,190",
    id: "Path",
    stroke: "#FFDD75",
    fillOpacity: 0,
    fill: "#FFFFFF",
    transform: "translate(432.500000, 333.000000) scale(-1, 1) rotate(-330.000000) translate(-432.500000, -333.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.773027,592 C207.662314,785.243089 300.519894,867.005743 488.345764,837.287962 C676.171635,807.570181 796.144221,891.474194 848.263522,1089",
    id: "Path-8",
    stroke: "#ECEFF2",
    strokeLinecap: "round",
    strokeDasharray: 10
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonDesktopBg);
export default __webpack_public_path__ + "static/media/reason-desktop-bg.3aaea4d2acd5e2458ea1ebd195478e62.svg";
export { ForwardRef as ReactComponent };